import { useTranslation } from "react-i18next";
import { ImageInfo } from "@/types";
import InfoImage from "@/components/infoImage";
import MainForm from "@/components/mainForm";

export default function Home() {
  const { t } = useTranslation("main");

  const infoImageData: ImageInfo[] = [
    { id: 1, text: t("info1") },
    { id: 2, text: t("info2") },
    { id: 3, text: t("info3") },
    { id: 4, text: t("info4") },
    { id: 5, text: t("info5") },
    { id: 6, text: t("info6") },
  ];

  return (
    <div className="mx-auto w-full sm:mt-8 sm:max-w-5xl lg:max-w-440">
      <div className="bg-primary-bg pb-1 pt-8 text-white lg:p-6">
        <div className="mb-5 grid grid-cols-2 gap-x-3 gap-y-7 px-6 py-4 sm:mx-3 sm:grid-cols-3 lg:m-0 lg:mb-8 lg:mt-2 lg:grid-cols-6 lg:p-0">
          {infoImageData.map(({ id, text }) => (
            <InfoImage key={id} text={text} />
          ))}
        </div>
        <MainForm />
      </div>
    </div>
  );
}
